export class AppChatInsRequest {
    user: string;
    s_chat: number;
    s_ins: number;
    s_inc: number;
    s_pc: number;
    s_cont: number;
    cix: number;
    s_svrq: number
    s_wo: number;
    chat_tp: number;
    chat_user: number;
    appuser_ind: number;
    text_msg: string;

    constructor(user: string, s_chat: number, s_ins: number, chat_tp: number, text_msg: string, s_pc: number, s_cont: number, cix: number, s_inc = 0,
        chat_user = 0, appuser_ind = 0, s_svrq = 0, s_wo =  0){
        this.s_ins = s_ins;
        this.user = user;
        this.text_msg = text_msg;
        this.s_inc = s_inc;
        this.s_pc = s_pc;
        this.s_cont = s_cont;
        this.cix = cix;
        this.chat_tp = chat_tp;
        this.chat_user = chat_user;
        this.appuser_ind = appuser_ind;
        this.s_chat = s_chat;
        this.s_svrq = s_svrq;
        this.s_wo = s_wo;
    }
}